// extracted by mini-css-extract-plugin
export default {"container":"ComparisonTable_container__bHS5M","comp_table":"ComparisonTable_comp_table__2gOf1","tabcomp_tablele":"ComparisonTable_tabcomp_tablele__COsCD"};